// ============================================================================
// frontend/src/components/tenant/ThemeSelector.tsx
// ============================================================================

import React from 'react';
import { THEME_PRESETS } from '@/constants/themes';

interface ThemeSelectorProps {
  selectedTheme: string;
  customTheme: boolean;
  onThemeSelect: (themeId: string) => void;
  onCustomThemeToggle: (enabled: boolean) => void;
}

export const ThemeSelector: React.FC<ThemeSelectorProps> = ({
  selectedTheme,
  customTheme,
  onThemeSelect,
  onCustomThemeToggle
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-medium">Choisir un thème</h3>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={customTheme}
            onChange={(e) => onCustomThemeToggle(e.target.checked)}
            className="rounded"
          />
          <span className="text-sm">Personnaliser</span>
        </label>
      </div>

      {!customTheme && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {THEME_PRESETS.map((theme) => (
            <button
              key={theme.id}
              type="button"
              onClick={() => onThemeSelect(theme.id)}
              className={`relative p-4 rounded-lg border-2 transition-all hover:shadow-md ${
                selectedTheme === theme.id
                  ? 'border-primary bg-primary/5'
                  : 'border-border hover:border-primary/50'
              }`}
            >
              {selectedTheme === theme.id && (
                <div className="absolute top-2 right-2 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
              
              <div className="text-3xl mb-2">{theme.icon}</div>
              <p className="font-medium text-sm mb-1">{theme.name}</p>
              <p className="text-xs text-muted-foreground leading-tight">
                {theme.description}
              </p>
              
              <div className="flex gap-1 mt-3">
                <div
                  className="w-6 h-6 rounded-full border border-border"
                  style={{ backgroundColor: theme.colors.primary }}
                  title="Couleur principale"
                />
                <div
                  className="w-6 h-6 rounded-full border border-border"
                  style={{ backgroundColor: theme.colors.dark_background }}
                  title="Fond sombre"
                />
                <div
                  className="w-6 h-6 rounded-full border border-border"
                  style={{ backgroundColor: theme.colors.accent }}
                  title="Accent"
                />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};